import { Composition } from 'remotion';
import * as SubtitleEffects from '../effects/SubtitleEffects';
import { SplitScreenComparisonComposition } from '../effects/SplitScreenComparison';
import {
  CSS2026FeaturesAnimation,
} from '../effects/Effects391-393';
import { BentoGrid2026 } from '../effects/BentoGrid2026';


// AIThoughtProcessVisualization: 文件不存在，保留占位以避免错误
// import { AIThoughtProcessVisualization } from '../effects/AIThoughtProcessVisualization';

import { CarbonNeutralityDashboard, defaultCarbonNeutralityDashboardProps } from '../effects/CarbonNeutralityDashboard';

import { BasketballTracking } from '../effects/BasketballTracking';
import { FootballTactics } from '../effects/FootballTactics';
import { FootballCoachCommentary } from '../effects/FootballCoachCommentary';
import { IsometricCityAnimation } from '../effects/IsometricCityAnimation';
import { AIChatInterface } from '../effects/AIChatInterface';

import { JingYeSi } from '../effects/JingYeSi';

import { LiquidBlobAnimation } from '../effects/LiquidBlobAnimation';
import { MatrixRain2 } from '../effects/MatrixRain2';
import { MorphingShapeGrid } from '../effects/MorphingShapeGrid';
import { MultiAgentCollaboration } from '../effects/MultiAgentCollaboration';
import { MultimodalAIFusion } from '../effects/MultimodalAIFusion';

import { NeuralNetworkFlow2026 } from '../effects/NeuralNetworkFlow2026';
import { Physics3DBouncingBalls } from '../effects/Physics3DBouncingBalls';
import { ProceduralCitySkyline } from '../effects/ProceduralCitySkyline';
import { RiverFlowSimulation } from '../effects/RiverFlowSimulation';
import { WebGLShaderEffect } from '../effects/WebGLShaderEffect';
import { HologramGlitchEffectComposition } from '../effects/HologramGlitchEffect';
import { AIEmotionWave } from '../effects/AIEmotionWave';
import { AIVoiceRecognition } from '../effects/AIVoiceRecognition';
// 2026-03-09 新效果 - 图片马赛克 + 水面波纹
import { ImageMosaic } from '../effects/ImageMosaic';
// 2026-03-09 新效果（从 feature 分支合并）
import { CyberpunkNeonEffect } from '../effects/CyberpunkNeonEffect';
import { HolographicParticles } from '../effects/HolographicParticles';
import { OpenClawDevoursWorld } from '../effects/OpenClawDevoursWorld';
import { ParticlePhysicsEngine } from '../effects/ParticlePhysicsEngine';
import { RotatingCardWall } from '../effects/RotatingCardWall';
import { Claymorphism3D } from '../effects/Claymorphism3D';
import { CountdownTimer } from '../effects/CountdownTimer';
import { CSSHoudiniPaintAPI } from '../effects/CSSHoudiniPaintAPI';
import { DataDrivenCharts, type DataDrivenChartsProps } from '../effects/DataDrivenCharts';
import { DataFlow } from '../effects/DataFlow';
import { ElectromagneticFieldSimulation } from '../effects/ElectromagneticFieldSimulation';
import { FragmentedTransition } from '../effects/FragmentedTransition';
import TextShatterEffect from '../effects/TextShatterEffect';
import { ImageDistortionTransition } from '../effects/ImageDistortionTransition';
import { InkRippleEffect } from '../effects/InkRippleEffect';
import { TypeWriterPro } from '../effects/TypeWriterPro';
import { Holographic3DProjection } from '../effects/Holographic3DProjection';
import { MorphingLiquidMetal } from '../effects/MorphingLiquidMetal';
import { HolographicText } from '../effects/HolographicText';
import { NeonGridFlow } from '../effects/NeonGridFlow';
import { GeometricShatter } from '../effects/GeometricShatter';
import { EnterpriseBrandingTemplate } from '../templates/EnterpriseBrandingTemplate';
import { LuluEcommerceVideo } from '../templates/LuluEcommerceVideo';
import { MathFormulaAnimation } from '../templates/educational/MathFormulaAnimation';
import { CodingTutorialAnimation } from '../templates/skills/CodingTutorialAnimation';
import { SciencePrincipleAnimation } from '../templates/educational/SciencePrincipleAnimation';
import { HealthTipsAnimation } from '../templates/life-knowledge/HealthTipsAnimation';
import { MindMapAnimation } from '../templates/thinking/MindMapAnimation';
import { PeriodicTableAnimation } from '../templates/academic/PeriodicTableAnimation';
import { DataVisualizationAnimation } from '../templates/skills/DataVisualizationAnimation';
import { GoalTrackingAnimation } from '../templates/thinking/GoalTrackingAnimation';
import { StressReliefAnimation } from '../templates/psychology/StressReliefAnimation';

export const Latest2026Compositions = () => (
  <>
      {/* 🎨 2026-03-06 新效果（#338-#340）✨ 每日研究任务 - 倒计时/彩纸/心形遮罩 */}
      <Composition
        id="CountdownTimer"
        component={CountdownTimer}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      <Composition
        id="DataFlow"
        component={DataFlow}
        durationInFrames={180}
        fps={30}
        width={1920}
        height={1080}
      />
      {/* 🎨 2026-03-06 新效果（#341-#343）✨ 每日研究任务 - WebGL/地形/神经网络 */}
      <Composition
        id="WebGLShaderEffect"
        component={WebGLShaderEffect}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      {/* 🎨 2026-03-06 新效果（#344-#346）✨ 每日研究任务 - 2026趋势 */}
      {/* 🎨 2026-03-06 新效果（#347-#349）✨ 每日研究任务 - 文化/节日/时间轴 */}
      {/* 🎨 2026-03-06 新效果（#350-#352）✨ 每日研究任务 - 3D/光影/音频 */}
      {/* 🎨 2026-03-06 新效果（#355-#357）✨ 每日研究任务 */}
      {/* 🎨 2026-03-06 新效果（#356-#358）✨ 炫酷游戏宣传 */}
      {/* 🔥 2026-03-06 炫酷游戏宣传模板 */}
      {/* 🎨 2026-03-06 新效果（#358-#360）✨ 每日研究任务 */}
      {/* 🎨 2026-03-06 新效果（#361-#363）✨ 2026 创意编码趋势 */}
      <Composition
        id="Physics3DBouncingBalls"
        component={Physics3DBouncingBalls}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      {/* 🎨 2026-03-06 新效果（#365-#366）✨ 每日研究任务 - 音频/流体 */}
      {/* 🎨 2026-03-06 新效果（#370-#372）✨ 每日研究任务 - 星云/全息/音频粒子 */}

      {/* 🎨 2026-03-06 新效果（#373-#375）✨ 每日研究任务 - WebGPU/深度学习/流体涡旋 */}

      {/* 🎨 2026-03-06 新效果（#379-#381）✨ 每日研究任务 - WebGPU光线追踪/GAN可视化/量子机器学习 */}

      {/* 🎨 2026-03-07 新效果（#388-#390）✨ 每日研究任务 - 动态排版/全息投影/物理布料 */}
      <Composition
        id="CSS2026FeaturesAnimation"
        component={CSS2026FeaturesAnimation}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      {/* 🎨 2026-03-07 新效果（#397-#399）✨ 前沿技术探索 */}
      <Composition
        id="ElectromagneticFieldSimulation"
        component={ElectromagneticFieldSimulation}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      {/* 🎨 2026-03-07 新效果（#403-#405）✨ 每日研究任务 - 多模态AI/决策树/注意力流 */}
      <Composition
        id="MultimodalAIFusion"
        component={MultimodalAIFusion}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      {/* 📝 字幕效果合集（15 种） */}
      <Composition
        id="TypewriterSubtitle"
        component={() => <SubtitleEffects.TypewriterSubtitle text="Remotion 字幕效果" fontSize={80} />}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      <Composition
        id="BounceSubtitle"
        component={() => <SubtitleEffects.BounceSubtitle text="弹跳文字效果" fontSize={80} />}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      <Composition
        id="BlurFadeSubtitle"
        component={() => <SubtitleEffects.BlurFadeSubtitle text="模糊淡入效果" fontSize={80} />}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      <Composition
        id="WaveSubtitle"
        component={() => <SubtitleEffects.WaveSubtitle text="波浪字幕效果" fontSize={80} />}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      <Composition
        id="OutlineSubtitle"
        component={() => <SubtitleEffects.OutlineSubtitle text="描边字幕效果" fontSize={80} />}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      <Composition
        id="GlowSubtitle"
        component={() => <SubtitleEffects.GlowSubtitle text="发光字幕效果" fontSize={80} />}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      <Composition
        id="RotateSubtitle"
        component={() => <SubtitleEffects.RotateSubtitle text="旋转字幕效果" fontSize={80} />}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      <Composition
        id="ScaleInSubtitle"
        component={() => <SubtitleEffects.ScaleInSubtitle text="缩放弹入效果" fontSize={80} />}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      <Composition
        id="Flip3DSubtitle"
        component={() => <SubtitleEffects.Flip3DSubtitle text="3D翻转效果" fontSize={80} />}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      <Composition
        id="TypeDeleteSubtitle"
        component={() => <SubtitleEffects.TypeDeleteSubtitle texts={["Remotion", "字幕效果", "打字机"]} fontSize={80} />}
        durationInFrames={180}
        fps={30}
        width={1920}
        height={1080}
      />
      <Composition
        id="ScrollingLinesSubtitle"
        component={() => <SubtitleEffects.ScrollingLinesSubtitle lines={["第一行字幕", "第二行字幕", "第三行字幕"]} fontSize={70} />}
        durationInFrames={120}
        fps={30}
        width={1920}
        height={1080}
      />
      <Composition
        id="RainbowSubtitle"
        component={() => <SubtitleEffects.RainbowSubtitle text="彩虹渐变字幕" fontSize={80} />}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      <Composition
        id="GlitchSubtitle"
        component={() => <SubtitleEffects.GlitchSubtitle text="故障文字效果" fontSize={80} />}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      {/* #406 液态气泡动画 */}
      <Composition
        id="LiquidBlobAnimation"
        component={LiquidBlobAnimation}
        durationInFrames={150}
        fps={30}
        width={1080}
        height={1920}
      />
      {/* #409 TypeWriter Pro - 专业打字机效果 */}
      <Composition
        id="TypeWriterPro"
        component={() => (
          <TypeWriterPro
            text={["Hello World!", "欢迎使用 Remotion", "TypeWriter Pro 效果演示"]}
            fontSize={48}
            color="#00FF00"
            syntaxHighlight={false}
            errorRate={0.05}
          />
        )}
        durationInFrames={300}
        fps={30}
        width={1920}
        height={1080}
      />
      {/* #411 Morphing Shape Grid - 形态变换网格 */}
      <Composition
        id="MorphingShapeGrid"
        component={MorphingShapeGrid}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      {/* #412 Procedural City Skyline - 程序化城市天际线·城市的一天 */}
      <Composition
        id="ProceduralCitySkyline"
        component={ProceduralCitySkyline}
        durationInFrames={300}
        fps={30}
        width={1920}
        height={1080}
      />
      {/* #415 River Flow Simulation - 河流流动模拟 */}
      <Composition
        id="RiverFlowSimulation"
        component={RiverFlowSimulation}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={720}
      />
      {/* #416 Multi-Agent Collaboration - 多智能体协作 */}
      <Composition
        id="MultiAgentCollaboration"
        component={MultiAgentCollaboration}
        durationInFrames={150}
        fps={30}
        width={1280}
        height={720}
      />
      {/* #417 Particle Life System - 粒子生命系统 */}
      {/* #418 Audio Waveform Visualization - 音频波形可视化 */}
      {/* #419 Procedural Terrain 3D - 程序化 3D 地形 */}
      {/* #420 GPU Instanced Particles - GPU 实例化粒子系统 */}
      {/* #421 CSS Houdini Paint API - CSS Houdini 绘制 API */}
      <Composition
        id="CSSHoudiniPaintAPI"
        component={CSSHoudiniPaintAPI}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      {/* #422 AI Motion Prediction - AI 运动预测 */}
      {/* #423 WebGPU Compute Particles - WebGPU Compute Shader 粒子系统 */}
      {/* #424 AI Voice Recognition - AI 语音识别可视化 */}
      <Composition
        id="AIVoiceRecognition"
        component={AIVoiceRecognition}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      {/* #429 Procedural Geometry Morphing - 程序化几何变形 */}
      {/* #430 Image Distortion Transition - 图像扭曲过渡 */}
      <Composition
        id="ImageDistortionTransition"
        component={ImageDistortionTransition}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      {/* #431 Flip 3D Transition - 3D 翻转转场 */}
      {/* #432 Fragmented Transition - 碎片化转场（破茧成蝶） */}
      <Composition
        id="FragmentedTransition"
        component={FragmentedTransition}
        durationInFrames={300}
        fps={30}
        width={1920}
        height={1080}
      />
      {/* #433 Particle Explosion Transition - 粒子爆炸转场 */}
      {/* #434 Data-Driven Charts - 数据驱动的动态图表 */}
      <Composition
        id="DataDrivenCharts"
        component={DataDrivenCharts}
        durationInFrames={210}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{
          title: '数据驱动的动态图表',
          subtitle: '商业数据可视化',
          data: [
            { label: 'Mon', value: 65, color: '#3b82f6' },
            { label: 'Tue', value: 85, color: '#8b5cf6' },
            { label: 'Wed', value: 45, color: '#ec4899' },
            { label: 'Thu', value: 95, color: '#f59e0b' },
            { label: 'Fri', value: 75, color: '#10b981' },
          ],
          background: 'linear-gradient(135deg, #1e3a8a 0%, #312e81 50%, #4c1d95 100%)',
        }}
      />
      {/* #437 AI Style Transfer - AI 风格迁移可视化 */}
      {/* #439 Claymorphism 3D - 粘土拟物 3D 效果 */}
      <Composition
        id="Claymorphism3D"
        component={Claymorphism3D}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      {/* #440 Bento Grid Showcase - Bento Grid 卡片布局展示 */}
      {/* #441 Light Trail Effect - 光晕追踪效果 */}
      {/* #442 Ink Ripple Effect - 水墨涟漪效果（东方美学） */}
      <Composition
        id="InkRippleEffect"
        component={InkRippleEffect}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      {/* #443 Matrix Rain 2.0 - 数字雨矩阵 2.0（数字觉醒叙事版） */}
      <Composition
        id="MatrixRain2"
        component={MatrixRain2}
        durationInFrames={540}
        fps={30}
        width={1920}
        height={1080}
      />
      {/* #447 AI Chat Interface - AI 聊天界面动画（2026 创意动画趋势） */}
      <Composition
        id="AIChatInterface"
        component={AIChatInterface}
        durationInFrames={390}
        fps={30}
        width={1920}
        height={1080}
      />
      {/* #448 Isometric City Animation - 等距城市动画（2026 创意动画趋势） */}
      <Composition
        id="IsometricCityAnimation"
        component={IsometricCityAnimation}
        durationInFrames={180}
        fps={30}
        width={1920}
        height={1080}
      />
      {/* #449 Gravity Field Visualization - 重力场可视化（2026 物理可视化趋势） */}
      {/* #452 静夜思 - 古诗词水墨动画 */}
      <Composition
        id="JingYeSi"
        component={JingYeSi}
        durationInFrames={270}
        fps={30}
        width={1920}
        height={1080}
      />
      {/* #453 Carbon Neutrality Dashboard - 碳中和数据仪表板（2026 ESG 趋势） */}
      <Composition
        id="CarbonNeutralityDashboard"
        component={CarbonNeutralityDashboard}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={defaultCarbonNeutralityDashboardProps}
      />
      {/* BlackHoleVisualization: 组件文件不存在，暂时禁用 */}
      {/* <Composition id="BlackHoleVisualization" component={BlackHoleVisualization} durationInFrames={150} fps={30} width={1920} height={1080} /> */}
      {/* AIThoughtProcessVisualization: 组件文件不存在，暂时禁用 */}
      {/* <Composition id="AIThoughtProcessVisualization" component={AIThoughtProcessVisualization} durationInFrames={150} fps={30} width={1920} height={1080} /> */}
      {/* #464 Bento Grid 2026 - 2026 年最流行的网格布局动画（2026 UI 趋势） */}
      <Composition
        id="BentoGrid2026"
        component={BentoGrid2026}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      {/* 2026-03-09 新效果（从 feature 分支合并） */}
      {/* #478 Cyberpunk Neon Effect - 赛博朋克霓虹（10/10） */}
      <Composition
        id="CyberpunkNeonEffect"
        component={CyberpunkNeonEffect}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      {/* #473 Holographic Particles - 全息量子引擎叙事动画（五幕 15s） */}
      <Composition
        id="HolographicParticles"
        component={HolographicParticles}
        durationInFrames={450}
        fps={30}
        width={1920}
        height={1080}
      />
      {/* #475 Magnetic Field Visualization - 磁场可视化（10/10） */}
      {/* #476 OpenClaw Devours World - OpenClaw 品牌动画（10/10） */}
      <Composition
        id="OpenClawDevoursWorld"
        component={OpenClawDevoursWorld}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      {/* #467 Particle Physics Engine - 粒子物理引擎（10/10） */}
      <Composition
        id="ParticlePhysicsEngine"
        component={ParticlePhysicsEngine}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      {/* #477 Rotating Card Wall - 旋转卡片墙（10/10） */}
      <Composition
        id="RotatingCardWall"
        component={RotatingCardWall}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      {/* #13 Basketball Tracking - 篮球投篮轨迹追踪（9.0/10） */}
      <Composition
        id="BasketballTracking"
        component={BasketballTracking}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      {/* #14 F1 Racing Graphics - F1 赛车数据可视化（9.5/10） */}
      {/* #15 Football Tactics - 足球战术演示（8.5/10） */}
      <Composition
        id="FootballTactics"
        component={FootballTactics}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      {/* #480 Neural Network Flow 2026 - 神经网络流动可视化（待评分） */}
      <Composition
        id="NeuralNetworkFlow2026"
        component={NeuralNetworkFlow2026}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      {/* #481 Image Mosaic - 图片马赛克拼图过渡（中优先级） */}
      <Composition
        id="ImageMosaic"
        component={ImageMosaic}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      {/* #483 Holographic 3D Projection - 全息 3D 投影（待评分） */}
      <Composition
        id="Holographic3DProjection"
        component={Holographic3DProjection}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      {/* #484 Crystal Prismatic Refraction - 水晶棱镜折射（待评分） */}
      {/* #485 Fluid Glassmorphism - 流体玻璃态（待评分） */}
      {/* #486 Morphing Liquid Metal - 变形液态金属（待评分） */}
      <Composition
        id="MorphingLiquidMetal"
        component={MorphingLiquidMetal}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      {/* #487 Holographic Text - 全息文字（待评分） */}
      <Composition
        id="HolographicText"
        component={HolographicText}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      {/* #488 Neon Grid Flow - 霓虹网格流光（待评分） */}
      <Composition
        id="NeonGridFlow"
        component={NeonGridFlow}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      {/* #490 Geometric Shatter - 几何破碎重组（待评分） */}
      <Composition
        id="GeometricShatter"
        component={GeometricShatter}
        durationInFrames={180}
        fps={30}
        width={1080}
        height={1920}
      />
      {/* #491 AI Emotion Wave - AI 情绪波形 */}
      <Composition
        id="AIEmotionWave"
        component={AIEmotionWave}
        durationInFrames={150}
        fps={30}
        width={1080}
        height={1920}
      />
      {/* #492 Football Coach Commentary - 足球教练解说视频 */}
      <Composition
        id="FootballCoachCommentary"
        component={FootballCoachCommentary}
        durationInFrames={690}
        fps={30}
        width={1080}
        height={1920}
      />
      {/* #493 Pixel Dissolve Transition - 像素溶解过渡（文件丢失，已禁用） */}
      {/* <Composition
        durationInFrames={90}
        fps={30}
        width={1920}
        height={1080}
      />
      /> */}
      {/* #494 Text Shatter Effect - 文字粉碎重组效果 */}
      <Composition
        id="TextShatterEffect"
        component={TextShatterEffect}
        durationInFrames={120}
        fps={30}
        width={1920}
        height={1080}
      />
      {/* #495 Hologram Glitch Effect - 全息故障效果 */}
      <Composition
        id="HologramGlitchEffect"
        component={HologramGlitchEffectComposition}
        durationInFrames={150}
        fps={30}
        width={1920}
        height={1080}
      />
      {/* #496 Split Screen Comparison - 分屏对比效果 */}
      <Composition
        id="SplitScreenComparison"
        component={SplitScreenComparisonComposition}
        durationInFrames={90}
        fps={30}
        width={1080}
        height={1920}
      />
      {/* #503 Enterprise Branding Template - 企业品牌宣传模板 */}
      <Composition
        id="EnterpriseBrandingTemplate"
        component={EnterpriseBrandingTemplate}
        durationInFrames={300}
        fps={30}
        width={1920}
        height={1080}
      />
      {/* #507 Lulu Ecommerce Video - Lulu电商促销视频 */}
      <Composition
        id="LuluEcommerceVideo"
        component={LuluEcommerceVideo}
        durationInFrames={300}
        fps={30}
        width={1080}
        height={1920}
      />
      {/* #508-513 教育视频效果模板 */}
      <Composition id="MathFormulaAnimation" component={MathFormulaAnimation} durationInFrames={360} fps={30} width={1920} height={1080} />
      <Composition id="CodingTutorialAnimation" component={CodingTutorialAnimation} durationInFrames={360} fps={30} width={1920} height={1080} />
      <Composition id="SciencePrincipleAnimation" component={SciencePrincipleAnimation} durationInFrames={360} fps={30} width={1920} height={1080} />
      <Composition id="HealthTipsAnimation" component={HealthTipsAnimation} durationInFrames={180} fps={30} width={1920} height={1080} />
      <Composition id="MindMapAnimation" component={MindMapAnimation} durationInFrames={180} fps={30} width={1920} height={1080} />
      <Composition id="PeriodicTableAnimation" component={PeriodicTableAnimation} durationInFrames={180} fps={30} width={1920} height={1080} />
      {/* #514-519 新增教育视频效果 */}
      <Composition id="DataVisualizationAnimation" component={DataVisualizationAnimation} durationInFrames={180} fps={30} width={1920} height={1080} />
      <Composition id="GoalTrackingAnimation" component={GoalTrackingAnimation} durationInFrames={180} fps={30} width={1920} height={1080} />
      <Composition id="StressReliefAnimation" component={StressReliefAnimation} durationInFrames={180} fps={30} width={1920} height={1080} />
  </>
);
